import React from 'react';
import { bool, string, func, number } from 'prop-types';
import InputNumber from '../InputNumber';

import './index.scss'

// El símbolo va como adorno visual, no como parte del valor: el input sigue entregando
// un número limpio (15, no "15 %") y el modo solo lectura de InputNumber lo conserva.
const InputPercent = (props) => {

    const { className, ...rest } = props;

    return (
        <div className="input-percent">
            <InputNumber className={`input-percent-control ${className}`} {...rest} />
            <span className="input-percent-symbol">%</span>
        </div>
    )
}

InputPercent.propTypes = {
    name: string.isRequired,
    placeholder: string,
    className: string,
    value: number,
    precision: number,
    allowNegative: bool,
    validation: func,
    onChange: func,
    disabled: bool
};

InputPercent.defaultProps = {
    placeholder: "",
    className: "",
    value: 0,
    precision: 2,
    allowNegative: false,
    // el guard de undefined es lo que permite vaciar el campo: sin él, isAllowed
    // rechaza el cambio y el backspace queda bloqueado
    validation: (value) => value === undefined || (value >= 0 && value <= 100),
    onChange: null,
    disabled: false
};

export default InputPercent;
